import axiosStudentInstance from "./axiosStudentInstance.js";
import { store } from "./redux/store.js";

axiosStudentInstance.interceptors.request.use(
  (config) => {
    const token = store.getState().authStudent?.studentToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosStudentInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const isRefreshRequest = originalRequest.url.includes("/refresh");

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !isRefreshRequest
    ) {
      originalRequest._retry = true;
      try {
        const refreshResponse = await axiosStudentInstance.post(
          "/student/refresh"
        );
        const studentToken = refreshResponse.data.studentToken;

        store.dispatch({
          type: "authStudent/refresh/fulfilled",
          payload: { studentToken },
        });

        originalRequest.headers["Authorization"] = `Bearer ${studentToken}`;
        return axiosStudentInstance(originalRequest);
      } catch (refreshError) {
        store.dispatch({ type: "authStudent/logout/fulfilled" });
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
